import { Routes, Route } from 'react-router-dom'
import { Box } from '@mantine/core'
import { Header } from '@/components/Header'
import { Navbar } from '@/components/Navbar'
import { Footer } from '@/components/Footer'
import { HomePage } from '@/pages/HomePage'
import { AboutPage } from '@/pages/AboutPage'
import { ServicesPage } from '@/pages/ServicesPage'
import { ContactPage } from '@/pages/ContactPage'
import { DocumentsPage } from '@/pages/DocumentsPage'
import { BookingPage } from '@/pages/BookingPage'
import { ListPage } from '@/pages/ListPage'
import { PaymentPage } from '@/pages/PaymentPage'

export function App() {

  return (
    <Box>

          <Header />
          <Navbar />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/list" element={<ListPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/booking" element={<BookingPage />} />
          </Routes>
      <Footer />
    </Box>
  )
}
